import { ActivatedRoute } from '@angular/router';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ModalDirective } from 'angular-bootstrap-md';

import { jsPDF } from "jspdf";
import autoTable from 'jspdf-autotable';

import { saveAs } from 'file-saver';
import { CommonService } from 'src/services/common/common.service';
import { ServiceManagerService } from 'src/services/service-manager.service';
import { SeoService } from 'src/services/seo/seo.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
@Component({
  selector: 'app-safety-plan',
  templateUrl: './safety-plan.component.html',
  styleUrls: ['./safety-plan.component.scss']
})
export class SafetyPlanComponent implements OnInit {

  currentSafetyPlanIndex: any = 0
  currentSlide: any = 1;
  finalSafetyPlan: any = {}
  isDownloading: boolean = false;
  safetyPlanList: any = [{
    "header": "safetyPlan.safetyPlan1.header",
    "content": "safetyPlan.safetyPlan1.content",
    "example": "safetyPlan.safetyPlan1.exampleText",
    "userInput": ""
  }, {
    "header": "safetyPlan.safetyPlan2.header",
    "content": "safetyPlan.safetyPlan2.content",
    "example": "safetyPlan.safetyPlan2.exampleText",
    "userInput": ""
  }, {
    "header": "safetyPlan.safetyPlan3.header",
    "content": "safetyPlan.safetyPlan3.content",
    "example": "safetyPlan.safetyPlan3.exampleText",
    "userInput": ""
  }, {
    "header": "safetyPlan.safetyPlan4.header",
    "content": "safetyPlan.safetyPlan4.content",
    "example": "safetyPlan.safetyPlan4.exampleText",
    "userInput": ""
  }, {
    "header": "safetyPlan.safetyPlan5.header",
    "content": "safetyPlan.safetyPlan5.content",
    "example": "safetyPlan.safetyPlan5.exampleText",
    "userInput": ""
  }, {
    "header": "safetyPlan.safetyPlan6.header",
    "content": "safetyPlan.safetyPlan6.content",
    "example": "safetyPlan.safetyPlan6.exampleText",
    "userInput": ""
  }]
  slideChanged: any = false;
  
  @ViewChild('downloadContent') downloadContent: ElementRef;
  @ViewChild('safetyPlanModal') showModal: ModalDirective | undefined;


  /**
   * Creates an instance of safety plan component.
   * @param commonService 
   * @param route 
   */
  constructor(
    public commonService: CommonService,
    private route: ActivatedRoute,
    private serviceManager: ServiceManagerService,
    private httpClient: HttpClient,
    private seoService: SeoService) {

    this.downloadContent = {} as ElementRef;

    var safetyPlan: any = localStorage.getItem("safetyContent")
    if (commonService.isFilled(safetyPlan)) {
      this.safetyPlanList = JSON.parse(atob(safetyPlan))
    }
    localStorage.setItem("safetyContent", btoa(JSON.stringify(this.safetyPlanList)))

    // Check routing url to show the different safety plan details
    route.queryParams.subscribe((params: any) => {
      if (params['type']) {
        this.viewSafetyPlan(params["type"] - 1)
      }
    })

  }

  ngOnInit(): void {
    this.seoService.setMetaTags(
      'Mental Health Safety Plan, Safety Plan for Suicidal Thoughts',
      'A mental health safety plan that helps you recognize warning signs, use coping strategies, and reach out for support during difficult moments.'
    );
  }

  /**
   * Views safety plan
   * @param index 
   */
  viewSafetyPlan(index: any) {
    this.currentSlide = 2
    this.currentSafetyPlanIndex = index
    var key = this.commonService.translateContent(this.safetyPlanList[this.currentSafetyPlanIndex].header)
    if (!this.finalSafetyPlan[key]) {
      this.finalSafetyPlan[key] = []
    }
  }

  /**
   * Shows safety plan edit page
   * @param slide 
   */
  showSafetyPlanEdit(slide: any) {
    this.showModal?.show()
    this.changeSlide(slide)
  }

  /**
   * Move to next safety plan
   * @param diff 
   */
  nextSafetyPlan(diff: any) {
    if ((diff < 0 && this.currentSafetyPlanIndex === 0)) {
      this.currentSlide = this.currentSlide == 2 ? 1 : 2
      return
    }
    if (this.currentSafetyPlanIndex === this.safetyPlanList.length - 1 && diff > 0) {
      return
    }
    this.currentSafetyPlanIndex += diff
  }

  /**
   * Changes slides like list page, details page and edit page
   * @param slide 
   */
  changeSlide(slide: any) {
    this.currentSlide = slide
  }

  /**
   * Saves safety plan to the local storage
   */
  saveSafetyPlan() {
    localStorage.setItem("safetyContent", btoa(JSON.stringify(this.safetyPlanList)))
    this.showModal?.hide()
    this.currentSlide = 2
  }

  /**
   * Cancels safety plan changes
   */
  cancelSafetyPlan() {
    var safetyPlan: any = localStorage.getItem("safetyContent")
    if (this.commonService.isFilled(safetyPlan)) {
      this.safetyPlanList = JSON.parse(atob(safetyPlan))
    }
    this.currentSlide = 2
    this.showModal?.hide()
  }

  /**
   * Downloads safety plan
   */
  downloadSafetyPlan() {
    this.isDownloading = true;
    var safetyPlan = JSON.parse(JSON.stringify(this.safetyPlanList))
    safetyPlan.forEach((safetyPlan: any, index: any) => {
      safetyPlan["header"] = this.commonService.translateContent(safetyPlan["header"]).toUpperCase()
      safetyPlan["content"] = this.commonService.translateContent(safetyPlan["content"])
      safetyPlan["example"] = this.commonService.translateContent(safetyPlan["example"])
      safetyPlan["index"] = index + 1
      
    });
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      responseType:  'blob' as 'json' 
    }
    var body = {
      "safety_plan" : safetyPlan
    }
    var url = this.serviceManager.getBackendUrl() + "download-safetyplan"
    this.httpClient.post<string>(url, body, httpOptions).subscribe((data: any) => {
      saveAs(data, "safetyPlan.pdf");
      this.isDownloading= false;
    },
    (error : any) => {
      console.log(error);  
      this.isDownloading = false;
    }
    )
    
  }
}
